/**
 * Heading and subheading for arm C (`form_first_ad_match`) of the challenge
 * page A/B/C test (Rob, 2026-10-02).
 *
 * These strings mirror, word for word, the top Google Ads text in the Proven
 * campaign as of 2026-10-02 (Google Ads scoreboard, last 14 days):
 * - heading: the top headline by far, "AI Trading for Beginners".
 * - subheading: the top long headline.
 *
 * When Proven's winning headline or long headline changes, update these two
 * strings to match. They are fixed text on purpose: no URL parameters and no
 * dynamic text, so every C visitor sees the same page.
 */
export const CHALLENGE_AD_MATCH_COPY = {
  heading: 'AI Trading for Beginners',
  subheading: 'Free 7-day AI trading challenge. Watch Claude research a real stock live.',
} as const;

export type ChallengeAdMatchCopy = typeof CHALLENGE_AD_MATCH_COPY;
